import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import saveTheCsv from 'save-csv'

import messages from './messages'

import './index.scss'

const Index = ({ simplifiedFields, allFields }: any) => {
  const intl = useIntl()

  const saveCsv = (fields: any, filename: any) => {
    const data = [
      fields.reduce((acc: any, { name, description }: any) => {
        // @ts-expect-error
        acc[name] = description || (messages['field_' + name] ? intl.formatMessage(messages['field_' + name]) : name)
        return acc
      }, {})
    ]

    saveTheCsv(data, {
      filename,
      formatter: (cell: any) => {
        return typeof cell === 'string' ? '"' + cell.replaceAll('"', '""') + '"' : cell
      }
    })
  }

  const saveSimpleCsv = (e: any) => {
    e.preventDefault()
    saveCsv(simplifiedFields, 'SimpleBulkAddExample.csv')
  }

  const saveAllCsv = (e: any) => {
    e.preventDefault()
    saveCsv(allFields, 'AllFieldsBulkAddExample.csv')
  }

  return (
    <span className="tooltip-upload-example">
      <div>
        <FormattedMessage {...messages.description} />
      </div>
      <div>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */}
        <a onClick={saveSimpleCsv}>
          <FormattedMessage {...messages.downloadSimple} />
        </a>{' '}
        <FormattedMessage {...messages.or} />
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */}
        <a onClick={saveAllCsv}>
          <FormattedMessage {...messages.downloadAll} />
        </a>
      </div>
    </span>
  )
}

Index.displayName = 'Tooltip'

Index.propTypes = {
  aggregateAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      urn: PropTypes.string.isRequired
    })
  ),
  simplifiedFields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ),
  allFields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  )
}

Index.defaultProps = {
  aggregateAttributes: []
}

export default Index
